import { createAction } from '@ngrx/store';

export const logout = createAction('[Auth] Logout');
